
import IconView from "@/components/objects/IconView.vue";
import InfographicStyleEditor from '@/components/profile/InfographicStyleEditor.vue';
import { DESIGN_VARIANTS } from "@/constants/ui.js";
import { hexToRgb, adjustColorBrightness } from "@/utils/helpers.js";

export default {
  name: "TheBlockHeader",
  components: { IconView, InfographicStyleEditor },
  inject: {
    specialProject: {
      default: false
    }
  },
  props: {
    listInfo: {
      type: Object
    },
    showDetail: {
      type: Boolean,
      default: false
    },
    column: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    design: {
      type: String,
    },
    template: {
      type: Object,
    },
    theme: {
      type: String,
    },
    blockName: {
      type: String,
    },
    imageType: {
      type: String,
    },
    screenName: {
      type: String,
    },
    screenId: {
      type: String,
    },
    whiteActions: {
      type: Boolean,
      default: true
    },
    showSource: {
      type: Boolean,
      default: false
    },
    unshowExports: {
      type: Boolean,
      default: false
    },
    sourceUrl: {
      type: String
    },
    user: {
      type: Object,
      default: () => {}
    },
    titleColor: {
      type: String,
    },
    bgColor: {
      type: String,
    },
    gradientEnabled: {
      type: Boolean,
    },
    gradientDirection: {
      type: String,
    },
    gradientShadowDirection: {
      type: String,
    },
    headerVariant: {
      type: String,
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    exportRight: {
      type: String,
      default: null
    },
    styles: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      templateValue: this.template
    }
  },

  computed: {
    getBlockName() {
      return this.imageType ? this.blockName + '_' + this.imageType : this.blockName
    },

    designVariantForExport() {
      if (this.headerVariant && DESIGN_VARIANTS[this.headerVariant]) {
        return this.headerVariant;
      }

      return this.getBlockName;
    },

    bgColorRgba() {
      if (!this.bgColor) {
        return 'rgba(50, 143, 229, 0.33)';
      }

      if (this.bgColor.startsWith('#')) {
        const rgb = hexToRgb(this.bgColor);
        return `rgba(${rgb}, 1)`;
      }

      if (this.bgColor.startsWith('rgba')) {
        return this.bgColor;
      }

      if (this.bgColor.startsWith('rgb(')) {
        const rgbValues = this.bgColor.match(/\d+/g);
        if (rgbValues && rgbValues.length >= 3) {
          return `rgba(${rgbValues[0]}, ${rgbValues[1]}, ${rgbValues[2]}, 1)`;
        }
      }

      return this.bgColor;
    },
    getHeaderBackground() {
      if (this.templateValue && !this.column) return

      switch(this.headerVariant) {
      case 'properties':
      case 'circle-links':
        if (this.gradientEnabled) {
          return { backgroundImage: `linear-gradient(to ${this.gradientDirection || 'bottom'}, ${this.bgColorRgba}, transparent)` };
        }
        return { backgroundColor: this.bgColor ?? null };
      case 'squar-links':
        if (this.gradientEnabled) {
          return { backgroundImage: `linear-gradient(to ${this.gradientDirection}, ${this.gradientShadowDirection === 'transparent' ? `${this.bgColor}, transparent` : `${this.bgColor}, ${adjustColorBrightness(this.bgColor, 1.20)}`})`, backgroundColor: 'transparent' }
        }
        return { backgroundColor: this.bgColor ?? 'var(--light-blue)' };
      default:
        return { backgroundColor: this.bgColor };
      }
    },
  },

  watch: {
    template: {
      handler(newVal) {
        this.templateValue = newVal
      },
      deep: true
    }
  },

  methods: {
    async onDetailInput(evt) {
      this.$emit('input', evt)

      if (this.templateValue) {
        await this.$store.dispatch('makeRealtimeExample', {
          elementId: this.screenId ? this.screenId : this.blockName ? `${this.blockName}-${this.listInfo.id}` : this.listInfo.id,
          title: !this.showLabel ? `${this.listInfo.object_label}` : `${this.listInfo.object_label}.  ${this.listInfo.label}`,
          icon: this.listInfo.icon,
          store: this.$store,
          styles: this.templateValue?.styles,
          headerColumn: this.value
        })
      }
    },

    async onDesignChange(evt) {
      this.$emit('design-change', evt)
    },

    styleTemplatesEdit(evt) {
      this.templateValue.styles = evt
      this.$emit('template-change', this.templateValue)
    },

    async onCloseEditPanel() {
      this.$emit('template-change', null)

      await this.$store.dispatch('makeRealtimeExample', {
        elementId: this.screenId ? this.screenId : this.blockName ? `${this.blockName}-${this.listInfo.id}` : this.listInfo.id,
        close: true
      })
    }
  }
}
